export const getAvailableProductData = (product, attribute) => {
    return attribute
        ? attribute in product
            ? product?.[attribute]
            : product?.master?.[attribute]
        : null
}
export const getProductData = (product, data, returnIfAnyAvailable) => {
    Object.entries(data).forEach((entry) => {
        data[entry[0]] = getAvailableProductData(product, entry[1])
    })

    const dataAvailable = !returnIfAnyAvailable
        ? Object.values(data).reduce((curr, next) => curr && (next || next === 0), true)
        : Object.values(data).some((value) => value || value === 0)
    return dataAvailable ? data : null
}

export const getImageByViewType = (product, viewType) => {
    return product.imageGroups?.filter((group) => group.viewType == viewType)[0]?.images[0]
}

export const hasWhatsIncluded = (product) => {
    return product?.c_whatsIncluded?.split('_')?.length > 0
}

export const getWhatsIncluded = (whatsIncluded) => {
    return whatsIncluded?.split('_').map((item) => {
        return {iconFlag: item.slice(0, 1), text: item.slice(item.indexOf('.') + 1)}
    })
}

export const getCharacteristicsJSONData = (product) => {
    const characteristicsJSON = product?.c_characteristicsJSON

    if (!characteristicsJSON) return null

    // skip top level of the array
    return JSON.parse(characteristicsJSON)
        .map(({value}) => value)
        .flat()
        .filter((data) => data?.name && data?.value)
}
